"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import React from "react";
import ReactDOM from "react-dom";
import $ from "jquery";
import * as popout from "./popout";
import { attachOcrLineDropListeners, forceString } from "./ocr_line_drop";
const ValueLinkTextDroppableInput = React.createClass({
  getInitialState: function() {
    return {
      identifier: ""
    };
  },
  componentDidMount() {
    const input = ReactDOM.findDOMNode(this.refs.input);
    $(input).droppable({
      drop: (event, ui) => {
        this.applyDroppedLine({
          chars: ui.helper.data("chars"),
          top: ui.helper.data("top"),
          left: ui.helper.data("left"),
          width: ui.helper.data("width"),
          height: ui.helper.data("height")
        });
      },
      scope: "dnd-text",
      activeClass: "ocred-document__drop-target"
    });
    this.detachOcrLineDrop = attachOcrLineDropListeners(
      input,
      this.applyDroppedLine
    );
    this.state.identifier = popout.setupDocPageLineFromPopoutListener(
      this.handlePopoutListenerUpdate
    );
  },
  componentWillUnmount() {
    if (this.detachOcrLineDrop) {
      this.detachOcrLineDrop();
    }
  },
  applyDroppedLine(line) {
    const value = forceString(line.chars);
    this.props.valueLink.requestChange(value);
    if (this.props.inputDropped) {
      this.props.inputDropped(value, {
        top: line.top,
        left: line.left,
        width: line.width,
        height: line.height
      });
    }
  },
  cleanedProps() {
    const props = Object.assign({}, this.props);
    if (typeof props.inputDropped !== "undefined") {
      delete props.inputDropped;
    }
    if (typeof props.hasLeadingText !== "undefined") {
      delete props.hasLeadingText;
    }
    return props;
  },
  handlePopoutListenerUpdate(value) {
    if (this.props.typeahead) {
      return this.props.inputDropped(value);
    }
    return this.props.valueLink.requestChange(value);
  },
  handleClick(e) {
    popout.setFieldSelection(this.state.identifier);
  },
  render() {
    if (this.props.v3ReskinEnabled) {
      return this.renderV3Reskin();
    }
    if (this.props.showTextArea) {
      return /* @__PURE__ */ React.createElement(
        "textarea",
        __spreadProps(__spreadValues({
          "data-component": "ValueLinkTextDroppableInput",
          ref: "input",
          rows: 1
        }, this.cleanedProps()), {
          onClick: this.handleClick
        })
      );
    } else {
      return /* @__PURE__ */ React.createElement(
        "input",
        __spreadProps(__spreadValues({
          ref: "input"
        }, this.cleanedProps()), {
          onClick: this.handleClick
        })
      );
    }
  },
  renderV3Reskin() {
    let className = "v3__input";
    if (this.props.hasLeadingText) {
      className += " v3__input--has-leading-text";
    }
    const props = {
      ref: "input",
      className,
      onClick: this.handleClick
    };
    if (this.props.showTextArea) {
      return /* @__PURE__ */ React.createElement("textarea", __spreadValues(__spreadValues({ rows: 1 }, props), this.cleanedProps()));
    } else {
      return /* @__PURE__ */ React.createElement("input", __spreadValues(__spreadValues({}, props), this.cleanedProps()));
    }
  }
});
export default ValueLinkTextDroppableInput;
